<template>
  <div ref="dressCodeRef" class="dresscode-container"> 
    <!-- Línea y título Dress Code animado -->
    <div ref="line1Ref" class="animated-line"></div>
    <div ref="dressCodeText" class="dresscode-title">DRESS CODE</div>

    <!-- Icono -->
    <img ref="iconRef" src="../assets/formal.svg" alt="Percha" class="vestimenta-icon" />

    <!-- Texto -->
    <div ref="text2Ref" class="text2">Formal    <br>Reservamos el color rosa para la quinceañera.</div>

   
    <div ref="line2Ref" class="animated-line"></div>
     <!-- Línea y acceso niños 
    <div ref="accesoText" class="acceso-title">NO NIÑOS</div>
    <div ref="textNiñosRef" class="text-niños">Respetuosamente no niños.</div>
-->
    <!-- Separador floral -->
    <img
      ref="separadorRef"
      src="@/assets/separador.png"
      alt="Separador floral"
      class="separador-final"
    />
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'DressCodeSection',
  setup() {
    const dressCodeRef = ref(null);
    const dressCodeText = ref(null);
    const line1Ref = ref(null);
    const iconRef = ref(null);
    const text2Ref = ref(null);
    const line2Ref = ref(null);
    const accesoText = ref(null);
    const textNiñosRef = ref(null);
    const separadorRef = ref(null);

    const animateElements = () => {
      gsap.fromTo(line1Ref.value, { width: 0 }, { width: "100%", duration: 1.5, ease: "power2.out" });
      gsap.fromTo(dressCodeText.value, { opacity: 0, x: -50 }, { opacity: 1, x: 0, duration: 1.2, ease: "power3.out", delay: 0.3 });
      gsap.fromTo(iconRef.value, { opacity: 0, scale: 0.7 }, { opacity: 1, scale: 1, duration: 1.2, ease: "power3.out", delay: 0.6 });
      gsap.fromTo(text2Ref.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 1.2, ease: "power3.out", delay: 0.9 });

      gsap.fromTo(line2Ref.value, { width: 0 }, { width: "100%", duration: 1.5, ease: "power2.out", delay: 1.2 });
      gsap.fromTo(accesoText.value, { opacity: 0, x: -50 }, { opacity: 1, x: 0, duration: 1.2, ease: "power3.out", delay: 1.5 });
      gsap.fromTo(textNiñosRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 1.2, ease: "power3.out", delay: 1.8 });

      // 🌸 Separador: entra al final desde abajo
      gsap.fromTo(separadorRef.value, { y: 50, opacity: 0 }, {
        y: 0,
        opacity: 1,
        duration: 1.2,
        ease: "power3.out",
        delay: 2.1
      });
    };

    onMounted(() => {
      nextTick(() => {
        ScrollTrigger.create({
          trigger: dressCodeRef.value,
          start: "top 85%",
          toggleActions: "play none none reset",
          onEnter: animateElements,
          onEnterBack: animateElements,
        });
      });
    });

    return {
      dressCodeRef,
      dressCodeText,
      line1Ref,
      iconRef,
      text2Ref,
      line2Ref,
      accesoText,
      textNiñosRef,
      separadorRef
    };
  }
};
</script>

<style scoped>
.dresscode-container {
  text-align: center;
  padding: 0px 20px 0;
  max-width: 600px;
  margin: 50px auto 0;
  position: relative;
  background-color: transparent;
}

.animated-line {
  width: 0;
  height: 2px;
  background-color: #e098a2;
  margin: 20px auto;
}

.dresscode-title,
.acceso-title {
  font-size: 24px;
  font-family: 'Playfair Display', serif;
  font-weight: bold;
  color: #e098a2;
  text-transform: uppercase;
  opacity: 0;
}

.vestimenta-icon {
  width: 105px;
  height: auto;
  margin: 25px 0;
  opacity: 0;
  filter: invert(1) grayscale(1);
}

.text2,
.text-niños {
  font-size: 19px;
  font-family: "Hearth Stone", sans-serif;
  font-weight: 500;
  color: #e098a2;
  margin-top: 10px;
  opacity: 0;
}

/* Separador floral final */
.separador-final {
  width: 50%;
  max-width: 300px;
  height: auto;
  display: block;
  margin: 0 auto;
  padding: 0;
  opacity: 0;
  transform: translateY(50px);
}
</style>
